export default __webpack_public_path__ + "static/media/forward.d1729e3f.svg";